import f from "../../../funcs";
import Events from "../../Events";


export default Events.extend("RemoveInsteadOfTrash", {

    init(storage) {
        storage.trash = async function(id, callback) {
            let ids = [id];
            if ( f.isArray(id) ) {
                ids = id;
            }
            ids = ids.map(function(id) {
                return id + "";
            });


            if ( f.isFunction(callback) ) {
                return await storage.remove(ids);
            }
            else {
                return storage.remove(ids, callback);
            }
        };
    }
});
